import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TheHeader from "./comm/TheHeader";
import {
  CButton,
  CCol,
  CCardBody,
  CFormGroup,
  CContainer,
} from "@coreui/react";
import TheNav from "./comm/TheNav";
import TheFooter from "./comm/TheFooter";
import ApoCntrFormPop from "./apoCntrFormPop";
import ApiHelper from "src/utils/api/api_helper";
import Swal from "sweetalert";
import { setApoCntrHdwtInfo, setApoCntrHdwtData } from "src/modules/apoCntrForm";
import { useHistory, useLocation } from "react-router-dom";
import { setReqTaskInfo } from "../../modules/insert";

const ApoCntrFormPage = () => {
  const { apoCntrForm, insert, main } = useSelector((state) => state);
  const dispatch = useDispatch();
  const history = useHistory();
  const corpNm = useLocation().pathname.split('/')[1];
  const pathParam = Number(useLocation().pathname.split('/')[2]);
  const [cntrFormItms, setCntrFormItms] = React.useState([]);
  const [apoCntrRegPop, setApoCntrRegPop] = React.useState({
    isOpen: false,
    itmCd: "",
  });
  // // 엠금융 체크 되도록
  // const [mCheck, setMCheck] = React.useState(false);
  const mfsApoCntrList = ['116','117','118','121'];
  const mfsCntrYn =  mfsApoCntrList.includes(main.taskNo);

  const onRegPopClose = () => {
    setApoCntrRegPop({ isOpen: false, itmCd: "" });
    document.getElementsByTagName("body")[0].style.overflow = "scroll";
  };

  const onRegistryClick = (e) => {
    setApoCntrRegPop({ isOpen: true, itmCd: e.target.value });
  };

  const handleHdwtForApoCntrSave = (e, nextPage) => {
    let params = {};
    let data = [];

    for (let item of apoCntrForm.apoCntrHdwtInfo) {
      if (item.update) {
        data.push({ hdwtCatCd: item.hdwtCatCd, imgData: item.data });
      }
    }

    params.reqNo = insert.reqTaskInfo.reqNo;
    params.data = JSON.stringify(data);
    
    let paramsFinan = {
      taskNo:main.taskNo,
      reqNo: insert.reqTaskInfo.reqNo,
      financialStat: insert.reqTaskInfo.financialStat, 
      financial2Stat: insert.reqTaskInfo.financial2Stat, 
      finAcdntCorpNm: insert.reqTaskInfo.finAcdntCorpNm, 
      finAcdntKind: insert.reqTaskInfo.finAcdntKind, 
      acdntDtm: insert.reqTaskInfo.acdntDtm, 
      acdntCtnt: insert.reqTaskInfo.acdntCtnt, 
      acdntDtlCtnt: insert.reqTaskInfo.acdntDtlCtnt, 
      dissCorpNm: insert.reqTaskInfo.dissCorpNm, 
      dissFinAcdntKind: insert.reqTaskInfo.dissFinAcdntKind, 
      dissDtm: insert.reqTaskInfo.dissDtm, 
      dissDtlCtnt: insert.reqTaskInfo.dissDtlCtnt, 
    };

    let paramAgree = {
      reqNo: insert.reqTaskInfo.reqNo,
      agreeYn: insert.reqTaskInfo.agreeYn
    }

    if (nextPage) {
      for (let checkForm of apoCntrForm.apoCntrHdwtInfo) {
        // 엠금융은 위촉계약서 > 모집종사자 부당행위 조치규정 서명 안 해도 넘어가도록        
        if (!checkForm.data)
        // {
        //   if(checkForm.hdwtCatCd == 'C07' && cntrFormItms[3].ITM_CD == 'AC046' && mCheck == true) {
        //     continue;
        //   }
          return Swal(
            "서류작성",
            "모든 서류를 확인하시고, 서명을 하셔야 다음으로 이동이 가능합니다.",
            "error"
          );
        //}
      }

      if(mfsCntrYn){
        if(paramsFinan.financialStat == null){
          return Swal(
            "서약서 동의서 약정서 이행 확인서",
            "위 계약서 내 '직전회사에서 금융사고 경력 유무' 값은 필수입니다.",
            "error"
          );
        }else if(paramsFinan.financial2Stat == null){
          return Swal(
            "서약서 동의서 약정서 이행 확인서",
            "위 계약서 내 '직전회사에서 금융사고로 현재 심의진행 유무' 값은 필수입니다.",
            "error"
          );
        }
      }

      {/* ABA 선택적 정보 동의여부 체크 */}
      if(main.corpNo == "39") {
        if(insert.reqTaskInfo.agreeYn == null || insert.reqTaskInfo.agreeYn == "") {
          return Swal(
            "선택적 정보",
            "개인(신용)정보 수집이용제공조회처리 동의서 내 '선택적 정보 수집·이용 동의 여부' 값은 필수입니다.",
            "error"
          );
        }
      }
    }
    
    if(main.corpNo == "51") {
      ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/tempSaveStep4Finan",
        paramsFinan
      ).then(({ data }) => {
        if(data.status === "INVALID"){
          return Swal(
            "서약서 동의서 약정서 이행 확인서",
            `위 계약서 내 '${data.msg}' 값은 필수입니다.`,
            "error"
          );
        }
      })
      .catch((err) => {
        console.error(err);
      });
    }

    if(main.corpNo == "39") {
      ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/tempSaveStep4Agree",
        paramAgree
      ).then(({ data }) => {
        if(data.status === "INVALID"){
          return Swal(
            "개인(신용)정보 수집이용제공조회처리 동의서 내 '선택적 정보 수집·이용 동의' 값은 필수입니다.",
            "error"
          );
        }
      })
      .catch((err) => {
        console.error(err);
      });
    }

    ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/tempSaveStep4And5",
      params
    ).then(({ data }) => {
        if (data.status === "SUCCESS") {
          if (nextPage) {
            history.push(`/${corpNm}/${pathParam + 1}`);
          } else {
            return Swal("", "임시저장 되었습니다.", "success");
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getInitData = async () => {
    let params = {};
    const _data = {};

    params.corpNo = main.corpNo;
    params.taskNo = main.taskNo;
    
    await ApiHelper.request(
      ApiHelper.methods.get,
      "/cust/request/cntrFormItms",
      params
    )
    .then(({ data }) => {
      if (data.status === "SUCCESS") {
        let result = data.data;
        
        setCntrFormItms(result.itm);
        
        if (apoCntrForm.isFirst) {
          dispatch(setApoCntrHdwtInfo(result.hdwt));
        }
      }
    })
    .catch((err) => {
      console.error(err);
    });

    await ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/reqTaskInfo",
      { reqNo: insert.reqTaskInfo.reqNo }
    )
    .then(({ data }) => {
      if (data.status === "SUCCESS") {
        let result = data.data[0];
        
        // 엠금융 금융사고 관련 정보
          _data.financialStat = result.FIN_ACDNT_YN;
          _data.finAcdntCorpNm = result.FIN_ACDNT_CORP_NM;
          _data.finAcdntKind = result.FIN_ACDNT_KIND;
          _data.acdntDtm = result.ACDNT_DTM;
          _data.acdntCtnt = result.ACDNT_CTNT;
          _data.acdntDtlCtnt = result.ACDNT_DTL_CTNT;
          _data.financial2Stat = result.DISS_FIN_YN;
          _data.dissCorpNm = result.DISS_CORP_NM;
          _data.dissFinAcdntKind = result.DISS_FIN_ACDNT_KIND;
          _data.dissDtm = result.DISS_DTM;
          _data.dissDtlCtnt = result.DISS_DTL_CTNT;
          
          // ABA 선택적 동의여부 정보
          _data.agreeYn = result.AGREE_YN;
        }
      })
      .catch((err) => {
        console.error(err);
      });

      await dispatch(setReqTaskInfo(_data, true));

  };

  React.useEffect(async () => {
    await getInitData();

    if (apoCntrForm.isFirst) {
      ApiHelper.request(ApiHelper.methods.post, "/cust/request/hdwtInfo1", {
        reqNo: insert.reqTaskInfo.reqNo,
      })
        .then(({ data }) => {
          if (data.status === "SUCCESS") {
            let result = data.data;
            dispatch(setApoCntrHdwtData(result, true));
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, []);

  return (
    <>
      <TheHeader />
      <div className="c-main">
      <TheNav step={main.step} />
        <CContainer className="text-left">
          <h5>
            <b>위촉계약서를 작성합니다.</b>
          </h5>
        </CContainer>
        <CCardBody className="bottom-card-body">
          { cntrFormItms.length > 0
            &&
            cntrFormItms.map((item) => {
              let hdwtData = item.HDWT_CAT_CD.split(',');
              let checkYn = true;

              if(hdwtData.length > 0 && apoCntrForm.apoCntrHdwtInfo.length > 0) {
                for(let i = 0; i < hdwtData.length; i++) {
                  checkYn = checkYn && (apoCntrForm.apoCntrHdwtInfo.filter((item) => item.hdwtCatCd === hdwtData[i])[0].data ? true : false);
                  //엠금융 금융사고 항목 처리 개발: AC039 운영 AC045
                  if(item.ITM_CD =='AC045' && (insert.reqTaskInfo.financialStat ==null || insert.reqTaskInfo.financial2Stat ==null)){
                    checkYn = false;
                  }
                                   
                }
              }

              return (
                <CFormGroup row className="mb-3 formCheckbox" key={item.ITM_CD}>
                  <CCol xs="2">
                  <label className="component-checkbox">
                      <input 
                        type="checkbox" 
                        id={item.ITM_CD}
                        name={item.ITM_CD}
                        value={item.ITM_CD}
                        onClick={onRegistryClick}
                        readOnly
                        checked={checkYn}
                        //checked={item.ITM_CD != 'AC046' ? checkYn :  mCheck == true}
                      />
                      <i />
                    </label>
                    {/* <CInputCheckbox
                      id="apoCntrForm1"
                      name="apoCntrForm1"
                      value="apoCntrForm1"
                      onClick={onRegistryClick}
                      readOnly
                      checked={
                        state.apoCntrForm.apoCntrHdwtInfo[0].data &&
                        state.apoCntrForm.apoCntrHdwtInfo[1].data
                          ? true
                          : false
                      }
                    /> */}
                  </CCol>
                  <CCol xs="10">
                    <CButton
                      className={ checkYn
                          ? 'isChecked'
                          : undefined }
                      color="primary"
                      variant="outline"
                      value={item.ITM_CD}
                      block
                      onClick={onRegistryClick}
                    >
                      {item.ITM_NM}
                    </CButton>
                  </CCol>
                </CFormGroup>
              )
            })
          }
          
          {/* <CFormGroup row className="mb-3 formCheckbox">
            <CCol xs="2">
              <label className="component-checkbox">
                <input 
                  type="checkbox" 
                  id="apoCntrForm2"
                  name="apoCntrForm2"
                  value="apoCntrForm2"
                  onClick={onRegistryClick}
                  readOnly
                  checked={
                    state.apoCntrForm.apoCntrHdwtInfo[2].data ? true : false
                  }
                />
                <i />
              </label>
            </CCol>
            <CCol xs="10">
              <CButton
                className={ state.apoCntrForm.apoCntrHdwtInfo[2].data
                    ? 'isChecked'
                    : undefined}
                color="primary"
                variant="outline"
                value="apoCntrForm2"
                block
                onClick={onRegistryClick}
              >
                보험설계사 서약서
              </CButton>
            </CCol>
          </CFormGroup>
          <CFormGroup row className="mb-3 formCheckbox">
            <CCol xs="2">
              <label className="component-checkbox">
                <input 
                  type="checkbox" 
                  id="apoCntrForm3"
                  name="apoCntrForm3"
                  value="apoCntrForm3"
                  onClick={onRegistryClick}
                  readOnly
                  checked={
                    state.apoCntrForm.apoCntrHdwtInfo[3].data ? true : false
                  }
                />
                <i />
              </label>
            </CCol>
            <CCol xs="10">
              <CButton
                className={ state.apoCntrForm.apoCntrHdwtInfo[3].data
                  ? 'isChecked'
                  : undefined}
                color="primary"
                variant="outline"
                value="apoCntrForm3"
                block
                onClick={onRegistryClick}
              >
                개인신용정보 이용동의서
              </CButton>
            </CCol>
          </CFormGroup>
          <CFormGroup row className="mb-3 formCheckbox">
            <CCol xs="2">
              <label className="component-checkbox">
                <input 
                  type="checkbox" 
                  id="apoCntrForm4"
                  name="apoCntrForm4"
                  value="apoCntrForm4"
                  onClick={onRegistryClick}
                  readOnly
                  checked={
                    state.apoCntrForm.apoCntrHdwtInfo[4].data ? true : false
                  }
                />
                <i />
              </label>
            </CCol>
            <CCol xs="10">
              <CButton
                className={ state.apoCntrForm.apoCntrHdwtInfo[4].data
                  ? 'isChecked'
                  : undefined}
                color="primary"
                variant="outline"
                value="apoCntrForm4"
                block
                onClick={onRegistryClick}
              >
                모집경력수집 동의서
              </CButton>
            </CCol>
          </CFormGroup>
          <CFormGroup row className="formCheckbox">
            <CCol xs="2">
             <label className="component-checkbox">
                <input 
                  type="checkbox" 
                  id="apoCntrForm5"
                  name="apoCntrForm5"
                  value="apoCntrForm5"
                  onClick={onRegistryClick}
                  readOnly
                  checked={
                    state.apoCntrForm.apoCntrHdwtInfo[5].data ? true : false
                  }
                />
                <i />
              </label>
            </CCol>
            <CCol xs="10">
              <CButton
                className={ state.apoCntrForm.apoCntrHdwtInfo[5].data
                  ? 'isChecked'
                  : undefined}
                color="primary"
                variant="outline"
                value="apoCntrForm5"
                block
                onClick={onRegistryClick}
              >
                지급확약서
              </CButton>
            </CCol>
          </CFormGroup> */}
          
        </CCardBody>
      </div>
      <TheFooter
        step={main.step}
        handleHdwtForApoCntrSave={handleHdwtForApoCntrSave}
      />
      {apoCntrRegPop.isOpen && (
        <ApoCntrFormPop
          modal={true}
          itmCd={apoCntrRegPop.itmCd}
          onClose={onRegPopClose}
          //mCheck={setMCheck}
        ></ApoCntrFormPop>
      )}
    </>
  );
};

export default ApoCntrFormPage;
